import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty, isUndefined } from "lodash";
import AhorrosInfo from "@components/AhorrosInfo/AhorrosInfo";
import { history } from "@helpers/history";
import { isObjEmpty } from "@helpers/utils";

const BORDER_TOP_COLOR = "#d7de00";

function AhorrosProgramados(props) {
  const {
    match: { params },
  } = props;
  const [idAhorro, setIdAhorro] = useState("");
  const [ahorro, setAhorro] = useState({});

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { ahorrosProgramados } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito.AhorroYCredito
  );

  useEffect(() => {
    setIdAhorro(params?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const defRoute = rutas?.filter(
      (route) => route?.name === "Ahorros Listado"
    );

    const prevRoute = defRoute.map((route) => {
      return {
        url: route.url.replace("/:id", ""),
        text: route.h1,
      };
    });

    if (!isEmpty(idAhorro) && !isEmpty(ahorrosProgramados)) {
      let promise = new Promise((resolve, reject) => {
        let normalizeAhorro = [];
        let resMatch = {};
        if (!isEmpty(ahorrosProgramados?.aCAhorroProgramado)) {
          normalizeAhorro = ahorrosProgramados.aCAhorroProgramado.map(
            (ahorro) => ({
              ...ahorro,
              idAhorro: ahorro.idAhorro.toLowerCase().replaceAll(" ", "-"),
              rutaPrevia: prevRoute,
            })
          );
          resMatch =
            normalizeAhorro &&
            normalizeAhorro.filter((ahorro) => ahorro.idAhorro === idAhorro)[0];
        }
        if (
          !isEmpty(ahorrosProgramados?.aCAhorroProgramado) &&
          !isEmpty(ahorrosProgramados?.aCBotonAhorro)
        ) {
          resMatch = {
            ...resMatch,
            btnSolicite: {
              image: ahorrosProgramados.aCBotonAhorro[0],
              url: resMatch?.urlFormularioSoliciteAqui?.url,
              alt: resMatch?.urlFormularioSoliciteAqui?.text,
            },
          };
        }
        resolve(resMatch);
      });

      promise.then((res) => {
        !isUndefined(res.btnSolicite.url) && !isEmpty(res)
          ? setAhorro({
              id: res.idAhorro,
              title: res.titulo,
              description: res.descripcion?.html,
              details: res.bag?.contentItems,
              btnSolicite: res.btnSolicite,
              prevRoute: res.rutaPrevia,
            })
          : isObjEmpty(ahorro) && history.push('/no-encontrado')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ahorrosProgramados, idAhorro]);

  return (
    <>
      {!isEmpty(ahorro) && (
        <AhorrosInfo ahorro={ahorro} borderTopColor={BORDER_TOP_COLOR} />
      )}
    </>
  );
}

export default AhorrosProgramados;
